<div class="container-fluid h-100 w-100 bg-transparent d-flex align-items-center">
    <div class="w-100">
        <div class="row w-100 d-flex justify-content-center">
            <img src="{{ imageLoad }}" class="img-fluid" />
        </div>
    </div>
</div>